/**
 * Transforms a flat structuredInfo dict into an ordered array of group objects.
 *
 * @param {Object} structuredInfo - Flat dict of field name -> fact data
 * @returns {Array} Ordered array of { name, groupOrder, facts, verifiedCount, totalCount }
 */
export default function groupFacts(structuredInfo) {
    if (!structuredInfo) return [];

    const groupMap = {};

    for (const [key, value] of Object.entries(structuredInfo)) {
        const groupName = value?.group || "Other";
        const groupOrder = value?.group_order ?? 999;

        if (!groupMap[groupName]) {
            groupMap[groupName] = {
                name: groupName,
                groupOrder,
                facts: [],
                verifiedCount: 0,
                totalCount: 0,
            };
        }

        groupMap[groupName].facts.push([key, value]);
        groupMap[groupName].totalCount += 1;
        if (value?.verified === true) {
            groupMap[groupName].verifiedCount += 1;
        }
    }

    const groups = Object.values(groupMap).sort((a, b) => a.groupOrder - b.groupOrder);
    // Stable sort within each group so facts don't shift on state updates
    for (const group of groups) {
        group.facts.sort(([a], [b]) => a.localeCompare(b));
    }
    return groups;
}
